import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useResourceLiveStreamQuery = createQueryHook(
  MembershipsCreatorV2ApiClient.getResourceLiveStream,
  {
    queryKey: ['resourceLiveStream'],
  },
)
